import { Box, Typography } from "@mui/material";

const scrollTextSx = {
    overflow: "auto",
    whiteSpace: "nowrap",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
};

const ListRowItem = ({ primary, sub1, sub2, sub3, right, href }) => {
    const hasSubtitle = Boolean(sub1 || sub2 || sub3);

    return (
        <Box
            component={href ? "a" : "div"}
            href={href}
            sx={{
                display: "flex",
                height: hasSubtitle ? 48 : 44,
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                px: "8px",
                py: "6px",
                borderRadius: "6px",
                textDecoration: "none",
                flexShrink: 0,
                "&:hover": { bgcolor: "action.hover" },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    minWidth: 0,
                    flex: 1,
                    mr: 1,
                }}
            >
                <Typography
                    sx={{
                        fontSize: 14,
                        color: "text.primary",
                        fontFamily: "Inter Tight, sans-serif",
                        lineHeight: 1.3,
                        ...scrollTextSx,
                    }}
                >
                    {primary}
                </Typography>
                {hasSubtitle && (
                    <Box
                        sx={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                        }}
                    >
                        {sub1 && (
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: "text.secondary",
                                    fontFamily: "Inter Tight, sans-serif",
                                    lineHeight: 1.3,
                                    ...scrollTextSx,
                                }}
                            >
                                {sub1}
                            </Typography>
                        )}
                        {sub1 && sub2 && (
                            <Box
                                sx={{
                                    width: 2,
                                    height: 2,
                                    borderRadius: "50%",
                                    bgcolor: "text.secondary",
                                    flexShrink: 0,
                                }}
                            />
                        )}
                        {sub2 && (
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: "text.secondary",
                                    fontFamily: "Inter Tight, sans-serif",
                                    lineHeight: 1.3,
                                    ...scrollTextSx,
                                }}
                            >
                                {sub2}
                            </Typography>
                        )}
                        {(sub1 || sub2) && sub3 && (
                            <Box
                                sx={{
                                    width: 2,
                                    height: 2,
                                    borderRadius: "50%",
                                    bgcolor: "text.secondary",
                                    flexShrink: 0,
                                }}
                            />
                        )}
                        {sub3 && (
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: "text.secondary",
                                    fontFamily: "Inter Tight, sans-serif",
                                    lineHeight: 1.3,
                                    ...scrollTextSx,
                                }}
                            >
                                {sub3}
                            </Typography>
                        )}
                    </Box>
                )}
            </Box>
            {right && <Box sx={{ flexShrink: 0 }}>{right}</Box>}
        </Box>
    );
};

export default ListRowItem;
